import { render, staticRenderFns } from "./BoxSteps.vue?vue&type=template&id=58b3d9ec&scoped=true"
import script from "./BoxSteps.vue?vue&type=script&lang=js"
export * from "./BoxSteps.vue?vue&type=script&lang=js"
import style0 from "./BoxSteps.vue?vue&type=style&index=0&id=58b3d9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b3d9ec",
  null
  
)

export default component.exports